import { ReactSVG } from 'react-svg';
import images from '../../constants/images';
import { Text } from '../SecondaryMarket';
import ViewReverse from '../ViewReverse';
import TopHeaderFunctional from './index.function';
import icons from '../../constants/icons';
import ConfirmModal from '../ConfirmModal';
import { useSelector } from 'react-redux';

const TopHeader = ({ handleLogout, onLogoutPress }) => {
  const { TextWeight, applicationId, confirmModal, setConfirmModal, authLoading, getContentKey, user } = TopHeaderFunctional();

  const accountOpeningData = useSelector((state) => state.content?.accountOpeningData);
  const user_mail = user?.clientEmail || accountOpeningData?.emailAddress

  return (
    <div>
      <ViewReverse className={'justify-between items-center py-3 px-4 md:px-12 bg-white border-b border-b-grey'}>
        <img src={images.logo} className='h-10' />

        <ViewReverse className={'gap-6'}>
          <ViewReverse className={'gap-2'}>
            <ReactSVG src={icons.application_icon} />
            <Text text={`Application no: ${applicationId ?? ''}`} weight={TextWeight.medium} />
          </ViewReverse>
          <ViewReverse className={'gap-2 hidden md:flex'}>
            <ReactSVG src={icons.email_icon} />
            <Text text={user_mail} weight={TextWeight.medium} />
          </ViewReverse>
          <ViewReverse className={'gap-2'} onClick={() => onLogoutPress ? onLogoutPress() : setConfirmModal(true)}>
            <ReactSVG src={icons.logout_icon} />
            <Text text={getContentKey('logout_btn')} weight={TextWeight.medium} />
          </ViewReverse>
        </ViewReverse>
      </ViewReverse>

      <ConfirmModal
        open={confirmModal}
        onClose={() => setConfirmModal(false)}
        title={getContentKey('logout_btn')}
        description={getContentKey('logout_confirmation')}
        loading={authLoading}
        onConfirm={handleLogout && handleLogout}
        acceptText={getContentKey('logout_btn')}
      />
    </div>
  );
};

export default TopHeader;
